module.exports = __webpack_public_path__ + "img/sj.330e9ffa.svg";